// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"hamburger-module--Wrapper--3MHeW","Hamburger":"hamburger-module--Hamburger--3lr02"};